'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp, _initialiseProps;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _redux = require('redux');

var _reactcss = require('reactcss');

var _reactcss2 = _interopRequireDefault(_reactcss);

var _orderBy = require('lodash/orderBy');

var _orderBy2 = _interopRequireDefault(_orderBy);

var _find = require('lodash/find');

var _find2 = _interopRequireDefault(_find);

var _reactabularDnd = require('reactabular-dnd');

var dnd = _interopRequireWildcard(_reactabularDnd);

var _reactEdit = require('react-edit');

var edit = _interopRequireWildcard(_reactEdit);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _reactDndHtml5Backend = require('react-dnd-html5-backend');

var _reactDndHtml5Backend2 = _interopRequireDefault(_reactDndHtml5Backend);

var _reactDnd = require('react-dnd');

var _reactabularUtils = require('reactabular-utils');

var _components = require('components');

var _reactabular = require('reactabular');

var _TableControls = require('./TableControls');

var _TableUtilities = require('./TableUtilities');

var _EnterpriseTableProps = require('./EnterpriseTableProps');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EnterpriseTableWrapper = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(EnterpriseTableWrapper, _Component);

  function EnterpriseTableWrapper(props) {
    (0, _classCallCheck3.default)(this, EnterpriseTableWrapper);

    var _this = (0, _possibleConstructorReturn3.default)(this, (EnterpriseTableWrapper.__proto__ || (0, _getPrototypeOf2.default)(EnterpriseTableWrapper)).call(this, props));

    _initialiseProps.call(_this);

    _this.state = {
      sortingColumns: {
        0: {
          direction: 'desc',
          position: 0
        }
      },
      originalColumns: props.columns,
      columns: _this.bindColumns(props),
      editedCell: null,
      rows: props.rows,
      selectedRow: {},
      query: {},
      pagination: props.pagination
    };
    return _this;
  }

  (0, _createClass3.default)(EnterpriseTableWrapper, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.state.originalColumns !== nextProps.columns) {
        this.setState({
          originalColumns: nextProps.columns,
          columns: this.bindColumns(nextProps)
        });
      }

      if (this.state.rows !== nextProps.rows) {
        this.setState({
          rows: nextProps.rows
        });
      }
    }
  }, {
    key: '_getStyle',
    value: function _getStyle() {
      var additionalProps = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return (0, _reactcss2.default)({
        default: {
          table: {
            width: this.props.tableWidth,
            maxHeight: this.props.tableHeight,
            tableLayout: this.props.tableLayout
          }
        }
      }, this.props, additionalProps);
    }

    // TODO row selection is currently not compatible with inline editing

  }, {
    key: 'render',
    value: function render() {
      var style = this._getStyle();
      var _state = this.state,
          columns = _state.columns,
          query = _state.query,
          sortingColumns = _state.sortingColumns,
          pagination = _state.pagination;
      var _props = this.props,
          reorderColumns = _props.reorderColumns,
          searchable = _props.searchable,
          className = _props.className,
          tableWidth = _props.tableWidth,
          classNames = _props.classNames,
          components = _props.components,
          rowKey = _props.rowKey;

      var styles = require('./EnterpriseTable.scss');

      /* Used to implement the DnD capabilities
      * Still needs the column header to be draggable = true */
      var tableComponents = (0, _extends3.default)({}, components, {
        header: {
          cell: dnd.Header
        }
      });
      if (reorderColumns) {
        tableComponents.body = (0, _extends3.default)({}, tableComponents.body, {
          row: dnd.Row
        });
      }
      if (!columns.length) {
        return null;
      }
      var searchColumns = void 0;
      if (searchable) {
        searchColumns = _react2.default.createElement(_reactabular.SearchColumns, {
          query: query,
          columns: columns,
          onChange: this.onSearch
        });
      }
      var rows = (0, _redux.compose)((0, _TableUtilities.paginate)(pagination), _reactabular.highlight.highlighter({ columns: columns, matches: _reactabular.search.matches, query: query }), _reactabular.search.multipleColumns({ columns: columns, query: query }))(this.state.rows);

      var _paginator = void 0;
      if (pagination && pagination.page && pagination.perPage) {
        _paginator = _react2.default.createElement(_TableControls.Paginator, {
          pagination: pagination,
          pages: rows.amount,
          onSelect: this.onSelectPage
        });
      }

      var addAction = void 0;
      if (this.props.addAction && this.props.onAdd) {
        addAction = _react2.default.createElement(
          _components.EnterpriseButton,
          {
            size: _components.ENTERPRISE_BUTTON_SIZES.MEDIUM,
            type: _components.ENTERPRISE_BUTTON_TYPES.PRIMARY,
            onClick: this.props.onAdd
          },
          'Add'
        );
      }
      // TODO make if statement to add virtualized capabilities, change for virtualized.body
      var _tableWidth = { width: tableWidth };
      return _react2.default.createElement(
        'div',
        {
          className: (0, _classnames2.default)(className, styles.root),
          style: _tableWidth
        },
        _react2.default.createElement(
          'div',
          { className: 'enterprise-table-actions' },
          addAction
        ),
        _react2.default.createElement(
          _reactabular.Table.Provider,
          {
            className: 'enterprise-table-body',
            components: tableComponents,
            columns: columns,
            style: style.table
          },
          _react2.default.createElement(
            _reactabular.Table.Header,
            {
              className: classNames.header && classNames.header.wrapper,
              style: _tableWidth
            },
            searchColumns
          ),
          _react2.default.createElement(_reactabular.Table.Body, {
            rows: _reactabular.resolve.resolve({ columns: columns, method: _reactabular.resolve.nested })(rows.rows),
            rowKey: rowKey,
            onRow: this.onRow,
            style: _tableWidth
          })
        ),
        _paginator
      );
    }
  }]);
  return EnterpriseTableWrapper;
}(_react.Component), _class.propTypes = _EnterpriseTableProps.propTypes, _class.defaultProps = _EnterpriseTableProps.defaultProps, _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.onSearch = function (query) {
    _this2.setState({ query: query });
  };

  this.onMove = function (labels) {
    // This returns a new instance, no need to cloneDeep.
    var movedColumns = dnd.moveLabels(_this2.state.columns, labels);

    if (movedColumns) {
      // Retain widths to avoid flashing while drag and dropping.
      var source = movedColumns.source;
      var target = movedColumns.target;

      var tmpClassName = source.props.className;
      source.props.className = target.props.className;
      target.props.className = tmpClassName;

      _this2.setState({
        columns: movedColumns.columns
      });
    }

    return movedColumns;
  };

  this.onRow = function (row, rowIndex) {
    var _props$onRow = _this2.props.onRow(row, rowIndex),
        className = _props$onRow.className,
        props = (0, _objectWithoutProperties3.default)(_props$onRow, ['className']);

    var finalProps = (0, _extends3.default)({
      className: (0, _reactabularUtils.mergeClassNames)(className, row.selected && 'selected-row')
    }, props);
    if (_this2.props.reorderColumns) {
      finalProps = (0, _extends3.default)({}, finalProps, {
        rowId: row.id,
        onMove: function onMove(o) {
          return _this2.onMoveRow(o);
        }
      });
    }
    return finalProps;
  };

  this.onMoveRow = function (_ref) {
    var sourceRowId = _ref.sourceRowId,
        targetRowId = _ref.targetRowId;

    var movedRows = dnd.moveRows(_this2.state.rows, { sourceRowId: sourceRowId, targetRowId: targetRowId });
    if (movedRows) {
      _this2.setState({
        rows: movedRows
      });
    }
  };

  this.onSelectPage = function (page) {
    var pages = Math.ceil(_this2.state.rows.length / _this2.state.pagination.perPage);

    _this2.setState({
      pagination: (0, _extends3.default)({}, _this2.state.pagination, {
        page: Math.min(Math.max(page, 1), pages)
      })
    });
  };

  this.bindColumns = function (_ref2) {
    var columns = _ref2.columns,
        styles = _ref2.styles;

    var getSortingColumns = function getSortingColumns() {
      return _this2.state.sortingColumns || {};
    };
    var sortable = _reactabular.sort.sort({
      getSortingColumns: getSortingColumns,
      onSort: function onSort(selectedColumn) {
        _this2.setState({
          sortingColumns: _reactabular.sort.byColumns({ // sort.byColumn would work too
            sortingColumns: _this2.state.sortingColumns,
            selectedColumn: selectedColumn
          })
        });
      },
      fieldName: 'property',
      styles: styles.sort
    });

    var editable = edit.edit({
      isEditing: function isEditing(_ref3) {
        var columnIndex = _ref3.columnIndex,
            rowData = _ref3.rowData;
        return columnIndex === rowData.editing;
      },
      onActivate: function onActivate(_ref4) {
        var columnIndex = _ref4.columnIndex,
            rowData = _ref4.rowData;

        _this2.props.onEdit(columnIndex, rowData.id);
        // const index = findIndex(this.state.rows, { id: rowData.id });
        // const rows = cloneDeep(this.state.rows);
        // rows[index].editing = columnIndex;
        // this.setState({ rows });
      },
      onValue: function onValue(_ref5) {
        var value = _ref5.value,
            rowData = _ref5.rowData,
            property = _ref5.property;

        _this2.props.onConfirmEdit(property, value, rowData.id);
        // const index = findIndex(this.state.rows, { id: rowData.id });
        // const rows = cloneDeep(this.state.rows);
        // rows[index][property] = value;
        // rows[index].editing = false;
        // this.setState({ rows });
      }
    });

    // TODO consider removing resetable feature
    // const resetable = sort.reset({
    //   event: 'onDoubleClick',
    //   getSortingColumns,
    //   fieldName: 'property',
    //   onReset: ({ sortingColumns }) => this.setState(sortingColumns)
    // });
    var result = columns.map(function (column, i) {
      if (column.header || column.cell) {
        var props = column.props || {};
        var header = column.header || {};
        var cell = column.cell || {};
        var existingHeaderProps = header.props;
        var existingHeaderFormat = header.format || function (v) {
          return v;
        };
        var existingHeaderTransforms = header.transforms || [];
        var existingCellFormat = cell.format || function (v) {
          return v;
        };
        var existingCellTransforms = cell.transforms || [];
        var newHeaderFormats = [existingHeaderFormat];
        var newHeaderProps = existingHeaderProps;
        var newHeaderTransforms = existingHeaderTransforms;
        var newCellFormat = existingCellFormat;
        var newCellTransforms = existingCellTransforms;

        if (_this2.props.sortable) {
          newHeaderFormats.push(_reactabular.sort.header({
            sortable: sortable,
            getSortingColumns: getSortingColumns,
            fieldName: 'property'
          }));
        }

        if (header.draggable) {
          newHeaderProps = {
            // DnD needs this to tell header cells apart
            label: header.label,
            onFinishMove: function onFinishMove() {
              return _this2.props.onMoveColumns(_this2.state.columns);
            },
            onMove: function onMove(o) {
              return _this2.onMove(o);
            }
          };
        }

        if (_this2.props.searchable) {
          newCellFormat = function newCellFormat(v, extra) {
            return _reactabular.highlight.cell(existingCellFormat(v, extra), extra);
          };
        }

        if (column.editable) {
          newCellTransforms.push(editable((0, _TableControls.TableInput)({ // eslint-disable-line new-cap
            autoFocus: true,
            name: column.property
          })));
        }

        var newHeaderFormat = function newHeaderFormat(value, extra) {
          return newHeaderFormats.reduce(function (parameters, format) {
            return {
              value: format(parameters.value, parameters.extra),
              extra: extra
            };
          }, { value: value, extra: extra }).value;
        };

        return (0, _extends3.default)({}, column, {
          props: (0, _extends3.default)({}, props, {
            className: (0, _reactabularUtils.mergeClassNames)((0, _TableUtilities.getColumnClassName)(_this2.id, i), props && props.className)
          }),
          header: (0, _extends3.default)({}, header, {
            props: newHeaderProps,
            transforms: newHeaderTransforms,
            format: newHeaderFormat
          }),
          cell: (0, _extends3.default)({}, cell, {
            format: newCellFormat,
            transforms: newCellTransforms
          })
        });
      }
      return null;
    });
    if (_this2.props.deleteAction && _this2.props.onDelete) {
      var deleteColumn = {
        props: {
          style: { minWidth: 50, width: 50 }
        },
        cell: {
          format: function format(value, _ref6) {
            var rowData = _ref6.rowData;
            return _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                'span',
                {
                  className: 'remove',
                  onClick: function onClick() {
                    return _this2.props.onDelete(rowData.id);
                  },
                  style: { marginLeft: '1em', cursor: 'pointer' }
                },
                '\u2717'
              )
            );
          }
        },
        width: 50,
        visible: true
      };
      result.push(deleteColumn);
    }
    return result;
  };
}, _temp);


EnterpriseTableWrapper.defaultProps = _EnterpriseTableProps.defaultProps;

/* DragDropContext is required to make the DnD functionality work */
var EnterpriseTable = (0, _reactDnd.DragDropContext)(_reactDndHtml5Backend2.default)(EnterpriseTableWrapper);
exports.default = EnterpriseTable;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/enterprise/EnterpriseTable/EnterpriseTable.jsx
// module id = 1610
// module chunks = 0